import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "settings-view" }
const _hoisted_2 = { class: "settings-content" }
const _hoisted_3 = { class: "settings-section" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "setting-row" }
const _hoisted_6 = { class: "setting-info" }
const _hoisted_7 = { class: "setting-value" }
const _hoisted_8 = { class: "setting-row" }
const _hoisted_9 = { class: "setting-control" }
const _hoisted_10 = { class: "settings-section" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "setting-row" }
const _hoisted_13 = { class: "setting-control" }
const _hoisted_14 = { class: "switch" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "status-message processing"
}
const _hoisted_17 = {
  key: 1,
  class: "status-message error"
}
const _hoisted_18 = {
  key: 2,
  class: "status-message success"
}
const _hoisted_19 = {
  key: 3,
  class: "permissions-info"
}
const _hoisted_20 = { class: "settings-section" }
const _hoisted_21 = { class: "card" }
const _hoisted_22 = { class: "setting-row" }
const _hoisted_23 = { class: "setting-control" }
const _hoisted_24 = { class: "switch" }

import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {

const router = useRouter();
const { user, enableGraphAccess, getGraphToken, isAuthenticated, initializeMsal, logout } = useAuth();

const graphAccessEnabled = ref(false);
const isProcessing = ref(false);
const errorMessage = ref("");
const statusMessage = ref("");

const userEmail = computed(() => user.value?.username || "");
const developerEnabled = ref(false);

// Check if Graph access is already enabled when component mounts
onMounted(async () => {
  // Ensure MSAL is initialized and only check Graph access if user is authenticated
  await initializeMsal();
  if (isAuthenticated.value) {
    await checkGraphAccess();
  } else {
    graphAccessEnabled.value = false;
  }
});

async function checkGraphAccess() {
  // Guard: don't attempt token acquisition if not authenticated
  if (!isAuthenticated.value) {
    graphAccessEnabled.value = false;
    return;
  }

  try {
    // Try to get a Graph token silently - if successful, Graph access is enabled
    await getGraphToken();
    graphAccessEnabled.value = true;
  } catch (error) {
    // If it fails, Graph access is not enabled - this is expected
    graphAccessEnabled.value = false;
  }
}

async function handleGraphAccessToggle() {
  if (!graphAccessEnabled.value) {
    // User is trying to disable - just update the UI
    // Note: In a real app, you might want to call a backend API to revoke consent
    return;
  }

  // User is trying to enable Graph access
  isProcessing.value = true;
  errorMessage.value = "";
  statusMessage.value = "Requesting Microsoft Graph access...";

  try {
    const result = await enableGraphAccess();
    
    if (result.success) {
      statusMessage.value = "Graph access enabled successfully!";
      setTimeout(() => {
        isProcessing.value = false;
        statusMessage.value = "";
      }, 2000);
    } else {
      if (result.error?.includes("Redirecting")) {
        statusMessage.value = "Redirecting to Microsoft for consent...";
        // Don't reset processing state - page will redirect
      } else {
        graphAccessEnabled.value = false;
        errorMessage.value = result.error || "Failed to enable Graph access";
        isProcessing.value = false;
        statusMessage.value = "";
      }
    }
  } catch (error) {
    graphAccessEnabled.value = false;
    errorMessage.value = "An error occurred while enabling Graph access";
    isProcessing.value = false;
    statusMessage.value = "";
    console.error("Graph access toggle error:", error);
  }
}

function goBack() {
  router.push({ name: "home" });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "settings-header" }, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "breadcrumb" }, "Home / Settings", -1)),
      _createElementVNode("div", { class: "header-row" }, [
        _createElementVNode("button", {
          onClick: goBack,
          class: "back-circle",
          "aria-label": "Go back"
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "18",
            height: "18",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("path", { d: "m12 19-7-7 7-7" })
          ], -1)
        ])),
        _cache[4] || (_cache[4] = _createElementVNode("h1", null, "Settings", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "section-label" }, "ACCOUNT", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "setting-label" }, "Signed in as", -1)),
              _createElementVNode("div", _hoisted_7, _toDisplayString(userEmail.value || 'Unknown User'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "setting-info" }, [
              _createElementVNode("div", { class: "setting-label" }, "Session"),
              _createElementVNode("div", { class: "setting-description" }, "Sign out of this device")
            ], -1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "ghost-btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(logout) && _unref(logout)(...args)))
              }, "Sign Out")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "section-label" }, "INTEGRATIONS", -1)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "setting-info" }, [
              _createElementVNode("div", {
                class: "setting-label",
                for: "graph-access"
              }, "Microsoft Graph Access"),
              _createElementVNode("div", { class: "setting-description" }, "Allow access to Microsoft 365 data (calendar, mail, files)")
            ], -1)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  id: "graph-access",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((graphAccessEnabled).value = $event)),
                  onChange: handleGraphAccessToggle,
                  disabled: isProcessing.value
                }, null, 40, _hoisted_15), [
                  [_vModelCheckbox, graphAccessEnabled.value]
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "slider" }, null, -1))
              ])
            ])
          ]),
          (isProcessing.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "spinner" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(statusMessage.value), 1)
              ]))
            : _createCommentVNode("", true),
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, " ⚠️ " + _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true),
          (graphAccessEnabled.value && !isProcessing.value && !errorMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, " ✅ Graph access is enabled "))
            : _createCommentVNode("", true),
          (graphAccessEnabled.value && !isProcessing.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[12] || (_cache[12] = [
                _createElementVNode("details", null, [
                  _createElementVNode("summary", null, "View granted permissions"),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, "Read your profile information"),
                    _createElementVNode("li", null, "Read your calendar events"),
                    _createElementVNode("li", null, "Read your emails"),
                    _createElementVNode("li", null, "Access your files in OneDrive")
                  ])
                ], -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "section-label" }, "DEVELOPER MODE", -1)),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "setting-info" }, [
              _createElementVNode("div", { class: "setting-label" }, "Enable developer features"),
              _createElementVNode("div", { class: "setting-description" }, "Show developer-only features in the UI")
            ], -1)),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((developerEnabled).value = $event))
                }, null, 512), [
                  [_vModelCheckbox, developerEnabled.value]
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "slider" }, null, -1))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})